import Vue from 'vue';
import Vuex from 'vuex';
import axios from '../plugins/axios.js';

Vue.use(Vuex);
interface State {
    permissions: any[];
    hasPermissionsLoaded: boolean;
}

export default new Vuex.Store<State>({
    state: {
        permissions: [],
        hasPermissionsLoaded: false,
    },
    mutations: {
        SET_PERMISSIONS(state, permissions: any[]) {
        state.permissions = permissions;
        state.hasPermissionsLoaded = true;
        },
    },
    actions: {
        async fetchPermissions({ commit, state }) {
        if (state.hasPermissionsLoaded) {
            return;
        }
        try {
            const { permissions } = await axios.get('/api/v1/');
            commit('SET_PERMISSIONS', permissions);
        } catch (error: any) {
            Vue.prototype.$message.error(error?.message || error || '加载权限失败');
        }
        },
    },
});
